(() => {
  if (!globalThis.OsoInstrumentCatalog) {
    const requests = new Map();
    globalThis.OsoInstrumentCatalog = {
      load(root = '/') {
        const base = new URL(root.replace(/\/?$/, '/') + 'collections/all', location.origin);
        base.searchParams.set('view', 'osito-data');
        const key = base.href;
        if (!requests.has(key)) {
          const task = (async () => {
            const page = async number => {
              const url = new URL(base);
              url.searchParams.set('page', String(number));
              const controller = new AbortController();
              const timer = setTimeout(() => controller.abort(), 20000);
              let response, html;
              try { response = await fetch(url, { signal: controller.signal }); html = await response.text(); }
              finally { clearTimeout(timer); }
              if (!response.ok) throw Error('catalog');
              const document = new DOMParser().parseFromString(html, 'text/html');
              const source = document.querySelector('[data-osito-catalog]');
              if (!source) throw Error('catalog');
              const result = JSON.parse(source.textContent);
              if (!Array.isArray(result.products) || !Number.isInteger(result.pages) || result.pages < 0 || result.pages > 250) throw Error('catalog');
              return result;
            };
            const first = await page(1);
            let products = first.products;
            for (let number = 2; number <= first.pages; number += 2) {
              const batch = await Promise.all([number, number + 1].filter(value => value <= first.pages).map(page));
              products = products.concat(...batch.map(result => result.products));
            }
            return [...new Map(products.map(product => [String(product.id), product])).values()]
              .map(product => ({ ...product, audio: product.audio || (product.sound?.kind === 'audio' ? product.sound.url : null) }));
          })();
          requests.set(key, task);
          task.catch(() => requests.delete(key));
        }
        return requests.get(key);
      }
    };
  }
  if (customElements.get('oso-recommendations')) return;
  customElements.define('oso-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.generation = (this.generation || 0) + 1;
      this.words = JSON.parse(this.querySelector('[data-recommendation-strings]').textContent);
      this.anchor = JSON.parse(this.querySelector('[data-anchor-product]').textContent);
      this.status = this.querySelector('[data-recommendation-status]');
      this.results = this.querySelector('[data-recommendation-results]');
      this.retry = this.querySelector('[data-recommendation-retry]');
      this.retry.addEventListener('click', () => this.load(), { signal: this.events.signal });
      this.hidden = false;
      if ('IntersectionObserver' in globalThis) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '500px' });
        this.observer.observe(this);
      } else this.load();
    }
    node(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      const generation = this.generation;
      this.retry.hidden = true;
      this.status.hidden = false;
      this.status.textContent = this.words.loading;
      try {
        const products = await globalThis.OsoInstrumentCatalog.load(this.dataset.root || '/');
        if (generation !== this.generation || !this.isConnected) return;
        const suggestions = globalThis.OsitoPairing.recommendations(this.anchor, products, { limit: 4, accessories: true });
        this.results.replaceChildren(...suggestions.map(suggestion => this.card(suggestion)));
        this.status.hidden = true;
        this.hidden = !suggestions.length;
      } catch {
        if (generation !== this.generation || !this.isConnected) return;
        this.status.textContent = this.words.error;
        this.retry.hidden = false;
      } finally {
        if (generation === this.generation) this.loading = false;
      }
    }
    card(suggestion) {
      const product = suggestion.product;
      const title = globalThis.OsitoPairing.clean(product.title);
      const card = this.node('article', 'oso-recommendations__card');
      if (product.image) {
        const link = this.node('a', 'oso-recommendations__image');
        link.href = product.url;
        link.setAttribute('aria-label', title);
        const image = this.node('img');
        image.src = product.image;
        image.alt = title;
        image.loading = 'lazy';
        image.width = 600;
        image.height = 600;
        link.append(image);
        card.append(link);
      }
      const heading = this.node('h3');
      const link = this.node('a', '', title);
      link.href = product.url;
      heading.append(link);
      const price = (product.priceVaries ? this.words.from + ' ' : '') + product.price;
      card.append(heading, this.node('p', 'oso-recommendations__price', price));
      let reason = this.words[suggestion.kind] || '';
      if (suggestion.group === 'harmonic' && suggestion.delta !== null && suggestion.delta !== undefined) reason += (reason ? ' · ' : '') + this.words.cents_match;
      if (reason) card.append(this.node('p', 'oso-recommendations__reason', reason));
      if (product.sound) {
        const player = this.node('oso-product-sound');
        player.dataset.context = 'card';
        player.dataset.title = title;
        const source = this.node('script');
        source.type = 'application/json';
        source.dataset.soundSource = '';
        source.textContent = JSON.stringify(product.sound);
        player.append(source);
        card.append(player);
      }
      return card;
    }
    disconnectedCallback() {
      this.generation++;
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
      this.loading = false;
    }
  });
})();